module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/05-01.bcb225b3.mp3";